package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_surcharge_in_house

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.toTwoDecimalString
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component.useDotDigitStatus
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import kotlin.math.max

@Composable
fun SurchargeInHouse(
    windowSizeMode: WindowSizeModeEnum,
    countryId: String,
    surchargeFrom: List<Int?>?,
    surchargeAmount: List<Int?>?,
    surchargePercent: List<Int?>?,
    updateSurcharge: (String, List<Int?>) -> Unit,

)
{
    if (windowSizeMode== WindowSizeModeEnum.Desktop)
    {
        Row(
            modifier = Modifier
                .fillMaxHeight()
                .fillMaxWidth()
                .padding(leftRight = Dimen.normalPadding)
                .borderRadius(Dimen.semiLargeRadius)
                .border(
                    width = Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb
                )
        ){

            content(
                surchargeFrom=surchargeFrom,
                surchargeAmount=surchargeAmount,
                surchargePercent=surchargePercent,
                countryId = countryId,
                updateSurcharge={fieldName,updatedList->
                    updateSurcharge(fieldName,updatedList)
                },
            )


        }
    }else
    {
        Column(
            modifier = Modifier
//                .margin(
//                    leftRight = Dimen.mediumPadding,
//                )
                .fillMaxHeight()
                .fillMaxWidth()
                .padding(leftRight = Dimen.normalPadding)
                .borderRadius(Dimen.lowBorderRadius)
                .border(
                    width = Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb
                )
        ){

            content(
                surchargeFrom=surchargeFrom,
                surchargeAmount=surchargeAmount,
                surchargePercent=surchargePercent,
                countryId = countryId,
                updateSurcharge={fieldName,updatedList->
                    updateSurcharge(fieldName,updatedList)
                },
            )


        }
    }

}

@Composable
private fun content(
    countryId:String,
    surchargeFrom: List<Int?>?,
    updateSurcharge: (String, List<Int?>) -> Unit,
    surchargeAmount: List<Int?>?,
    surchargePercent: List<Int?>?
) {
    SurchargeContent(
        surchargeList = surchargeFrom?: listOf(),
        title = Strings.current().away,
        countryId = countryId,
        updateSurcharge = {
            updateSurcharge(
                ApiUtils.Field.surchargeFrom,
                it
            )
        }
    )

    SurchargeContent(
        surchargeList = surchargeAmount?: listOf(),
        title = Strings.current().surchargeAmount,
        countryId = countryId,
        updateSurcharge = {
            updateSurcharge(
                ApiUtils.Field.surchargeAmount,
                it
            )
        }
    )
    SurchargeContent(
        surchargeList = surchargePercent?: listOf(),
        title = Strings.current().surchargePercent,
        countryId = countryId,
        updateSurcharge = {
            updateSurcharge(
                ApiUtils.Field.surchargePercent,
                it
            )
        }
    )
}

@Composable
fun SurchargeContent(
    surchargeList: List<Int?>,
    countryId:String,
    title: String,
    updateSurcharge:(List<Int?>)->Unit,
) {
//
    val mutableSurchargeList = remember {
        mutableStateOf(surchargeList.toMutableList())
    }

    val maxIndex = remember { mutableStateOf(1) }
    LaunchedEffect(surchargeList)
    {
        mutableSurchargeList.value = surchargeList.toMutableList()
        var initialCount = 0
        var i = surchargeList.size - 1
        while (i >= 0) {
            if (surchargeList[i] != null) {
                initialCount = i + 1
                break
            }
            i--
        }
        maxIndex.value = max(1, initialCount+1)
    }
    val isFocused= remember { mutableStateOf(false) }
    val value=mutableSurchargeList.value.getOrNull(0)

    Column(
        modifier = Modifier
    ) {
        MediumContentTitle(
            title = title
        )

        CustomEditText(
            modifier = Modifier,
            width = Dimen.extraSemiMediumEditText,
            value =if (isFocused.value) value.toString() else
                value?.toDouble()
                    .toTwoDecimalString(useDotDigitStatus(countryId)),
            isRequired = false,
            inputType = InputType.Number,
            isOutlinedEditText = true,
            usingDotForDigit = useDotDigitStatus(countryId),
            onCloseIconClick = {
                mutableSurchargeList.value[0]=null
                mutableSurchargeList.value.removeAt(0)
                updateSurcharge(mutableSurchargeList.value)
            },
            onFocusOutIsActiveWithoutAnyChange = true,
            onFocusIn = {
                isFocused.value=true

            },
            onFocusOut = {
                isFocused.value=false
                if (it!=value.toString()){
                    if (it.isEmpty())
                        mutableSurchargeList.value[0] = null
                    else
                        mutableSurchargeList.value[0] = it.toInt()
                    updateSurcharge(mutableSurchargeList.value)
                }


            },
            onInputChange = {it, validation -> },
        )


//        mutableSurchargeList.value.forEachIndexed { index, value ->
//
//            val isFocused= remember { mutableStateOf(false) }
//            if (index < maxIndex.value) {
//                Row(
//                    verticalAlignment = Alignment.CenterVertically
//                ){
//                    CustomEditText(
//                        modifier = Modifier,
//                        width = Dimen.extraSemiMediumEditText,
//                        value =if (isFocused.value) value.toString() else
//                        value?.toDouble()
//                            .toTwoDecimalString(useDotDigitStatus(countryId)),
//                        isRequired = false,
//                        inputType = InputType.Number,
//                        isOutlinedEditText = true,
//                        usingDotForDigit = useDotDigitStatus(countryId),
//                        onCloseSearchBarIconClick = {
//                            mutableSurchargeList.value[index]=null
//                            mutableSurchargeList.value.removeAt(index)
//                            updateSurcharge(mutableSurchargeList.value)
//                        },
//                        onFocusOutIsActiveWithoutAnyChange = true,
//                        onFocusIn = {
//                            isFocused.value=true
//
//                        },
//                        onFocusOut = {
//                            isFocused.value=false
//                            if (it!=value.toString()){
//                                if (it.isEmpty())
//                                    mutableSurchargeList.value[index] = null
//                                else
//                                    mutableSurchargeList.value[index] = it.toInt()
//                                updateSurcharge(mutableSurchargeList.value)
//                            }
//
//
//                        },
//                        onInputChange = {it, validation ->
//                            if (index == maxIndex.value - 1
//                                && maxIndex.value < surchargeList.size) {
//                                maxIndex.value++
//                            }
//
//                        },
//                    )
//
//
//
//                }
//
//
//
//            }
//        }
    }
}